module.exports = __webpack_public_path__ + "static/about-ari-ab61f624d458adcf3fbc15b316a65425.png";